import { ReactComponent as Account } from 'assets/account.svg'
import { ReactComponent as Padlock } from 'assets/padlock.svg'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Submit from 'components/inputs/Submit'
import Input from 'components/inputs/Input'
import { fetchLogIn } from './loginSlice'
import { useDispatch } from 'react-redux'
import { useState } from 'react'

const Form = ({ callback }) => {
  const [isSending, setSending] = useState(false)
  const [form, setForm] = useState({
    mail: '',
    password: '',
  })
  const [warning, setWarning] = useState({
    mail: false,
    password: false,
  })

  const refs = []

  const { push } = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation('form')

  const changeHandler = e => {
    if (!e) return
    const { name, value } = e.target

    setForm({
      ...form,
      [name]: value
    })
    if (value && warning[name]) setWarning({
      ...warning,
      [name]: false
    })
  }

  const enterClicked = ref => {
    const index = refs.findIndex(r => Object.is(r, ref))
    if (index === -1) return
    if (refs[index + 1]) refs[index + 1].focus()
    else if (index + 1 === refs.length && !isSending) submit()
  }

  const submit = () => {
    const { mail, password } = form

    if (mail && password) {
      const body = { username: mail, password }
      setSending(true)
      dispatch(fetchLogIn(body)).then(({ payload }) => {
        callback?.(payload)
        setSending(false)
      })

    } else setWarning({
      mail: !mail,
      password: !password
    })
  }

  return (
    <div className='login__form'>
      <Input
        disabled={isSending}
        ref={r => refs.push(r)}
        value={form.mail}
        name='mail'
        label={t('login')}
        minLength='1'
        maxLength='200'
        icon={<Account />}
        warning={warning.mail}
        placeholder={t('phoneNumberOrEmail')}
        enterClicked={enterClicked}
        changeHandler={changeHandler} />

      <Input
        disabled={isSending}
        ref={r => refs.push(r)}
        value={form.password}
        name='password'
        type='password'
        label={t('password')}
        minLength='6'
        maxLength='90'
        placeholder={t('password')}
        icon={<Padlock />}
        warning={warning.password}
        enterClicked={enterClicked}
        changeHandler={changeHandler} />

      <Submit
        text={t('logIn')}
        isLoading={isSending}
        action={submit}
      />

      <p
        className='--secondary'
        onClick={() => push('/login/reset')}>
        {t('forgotYourPassword')}
      </p>
    </div>
  )
}

export default Form